const o = "style-module__loadingIcon___ijhQj", n = {
  loadingIcon: o
};
export {
  n as default,
  o as loadingIcon
};
